import { FC } from "react";
import { Outlet } from "react-router-dom";

const MachineLayout: FC = () => (
  <div
    style={{
      position: "relative",
      height: "100vh",
      width: "100%",
      background: "linear-gradient(107.56deg, #36254D 0%, #211530 100%)",
      // background: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Outlet />
    <div
      style={{
        position: "fixed",
        bottom: 40,
        left: "50%",
        color: "white",
        transform: "translate(-50%, 0)",
      }}
    >
      <p>
        <span
          style={{
            fontSize: "1rem",
          }}
        >
          ©{new Date().getFullYear()} Powered by{" "}
          <a
            style={{ cursor: "pointer", color: "white" }}
            href="https://techpartners.asia/"
            target="_blank"
            rel="noreferrer"
          >
            “Tech partners” LLC
          </a>
        </span>
      </p>
    </div>
  </div>
);

export default MachineLayout;
